interface IAuthorDetails {
  name: string;
}
export const AuthorDetails: React.FC<IAuthorDetails> = ({ name }) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    // Defer scroll to next frame to avoid blocking the interaction
    requestAnimationFrame(() => {
      const authorBio = document.getElementById('authorBio');
      if (authorBio) {
        authorBio.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  };

  return (
    <>
      <a
        href="#authorBio"
        onClick={handleClick}
        className="text-s-12 text-font-500 self-center underline py-2  sm:text-s-10 sm:py-0 sm:my-1  sm:w-full"
      >
        By {name}
      </a>
      <p className="self-center sm:hidden"> | </p>
    </>
  );
};
